import { render } from "./TheSIdebar.vue?vue&type=template&id=21ac0ca0&scoped=true"
import script from "./TheSIdebar.vue?vue&type=script&lang=js"
export * from "./TheSIdebar.vue?vue&type=script&lang=js"

import "./TheSIdebar.vue?vue&type=style&index=0&id=21ac0ca0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ac0ca0"]])

export default __exports__